import { SourceApps, Calendar, Restaurant } from '@maverick/entity';
import { RestaurantService } from '../services/olo/Restaurant.service';

export class HandoffManager {
    private readonly restaurantService: RestaurantService;

    constructor(sourceApp: SourceApps) {
        this.restaurantService = new RestaurantService(sourceApp);
    }

    async getRestaurant(restaurantId: number): Promise<Restaurant | null> {
        const response = await this.restaurantService.getRestaurant({ restaurantId });

        if (response.error) return null;

        return Restaurant.Make(response.body);
    }

    async getRestaurantCalendarById(
        restaurantId: number
    ): Promise<Partial<{ calendar: Array<Calendar>; error: string }>> {
        const response = await this.restaurantService.getRestaurantCalendar({ restaurantId });

        if (response.error) {
            return { error: response.errorMessage };
        }

        const calendar = response.body.calendar.map((c: any) => {
            return Calendar.Make(c);
        });

        return { calendar: calendar };
    }
}
